export default __webpack_public_path__ + "static/media/pvilla7-2.967f7b48.jpg";